import React, { useEffect, useState } from "react";
import "./TermsAndCondition.css";
import { useDispatch } from "react-redux";
import { getPageDeatailsAPI } from "../../../../../Store/Action/pageAction";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import CustomLoader from "../../../CustomComponents/CustomLoader/CustomLoader";
import Icons from "../../../../../Config/Images";

const TermsAndCondition = ({ showHeaderFooter }) => {
  const dispatch = useDispatch();

  const [termsContent, setTermsContent] = useState([]);
  const [header, setHeader] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const pageSlug = "terms-conditions";
    dispatch(
      getPageDeatailsAPI(pageSlug, (result) => {
        // if (result?.status) {
        setHeader(result.data?.[0]?.page_name);
        setTermsContent(result?.data?.[0]?.page_json);
        setIsLoading(false);
        // }
      })
    );
  }, [dispatch]);

  const renderTermsPoints = () =>
    termsContent?.map((term, index) => (
      <div className="terms-conditions-point">
        <p>
          {`${index + 1}.`} {term.header}
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li key={index}>{term.content}</li>
        </ul>
      </div>
    ));

  return (
    <>
      {showHeaderFooter && <Header />}

      <div
        className="terms-and-conditions-main-div with-overlay"
        style={{
          backgroundImage: `url(${Icons.zabali_header_logo_icon})`,
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          // backgroundPosition: "top center", // or 'center center'
          backgroundPosition: "center center",
          
        }}
      >
        <div className="terms-conditions-header">
          <p className="terms-conditions-header-para">
            {header || "terms & Conditions"}
          </p>
        </div>
        <div className="divider" />
        {isLoading ? (
          <>
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          </>
        ) : (
          <div className="terms-conditions-container">
            {renderTermsPoints()}
          </div>
        )}
      </div>
      {/* {showHeaderFooter && <Footer />} */}
      <Footer />
    </>
  );
};

export default TermsAndCondition;
